"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notification = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("../../../mantine-theme/src");
var Paper_1 = require("../Paper/Paper");
var Text_1 = require("../Text/Text");
var Loader_1 = require("../Loader/Loader");
var ActionIcon_1 = require("../ActionIcon/ActionIcon");
var CloseIcon_1 = require("../Modal/CloseIcon");
var Notification_styles_1 = __importDefault(require("./Notification.styles"));
function Notification(_a) {
    var _b;
    var className = _a.className, _c = _a.color, color = _c === void 0 ? 'blue' : _c, _d = _a.loading, loading = _d === void 0 ? false : _d, _e = _a.disallowClose, disallowClose = _e === void 0 ? false : _e, title = _a.title, icon = _a.icon, children = _a.children, onClose = _a.onClose, closeButtonProps = _a.closeButtonProps, themeOverride = _a.themeOverride, others = __rest(_a, ["className", "color", "loading", "disallowClose", "title", "icon", "children", "onClose", "closeButtonProps", "themeOverride"]);
    var classes = Notification_styles_1.default({ color: color, disallowClose: disallowClose, theme: theme_1.useMantineTheme(themeOverride) });
    return (react_1.default.createElement(Paper_1.Paper, __assign({ shadow: "lg", padding: "sm", className: clsx_1.default(classes.notification, (_b = {}, _b[classes.withIcon] = icon || loading, _b), className), role: "alert", themeOverride: themeOverride }, others),
        icon && !loading && (react_1.default.createElement("div", { "data-mantine-icon": true, className: classes.icon }, icon)),
        loading && react_1.default.createElement(Loader_1.Loader, { size: 28, color: color, className: classes.loader }),
        react_1.default.createElement("div", { className: classes.body },
            title && (react_1.default.createElement(Text_1.Text, { "data-mantine-title": true, className: classes.title, size: "sm", weight: 500, themeOverride: themeOverride }, title)),
            react_1.default.createElement(Text_1.Text, { "data-mantine-body": true, className: classes.description, size: "sm", themeOverride: themeOverride }, children)),
        !disallowClose && (react_1.default.createElement(ActionIcon_1.ActionIcon, __assign({}, closeButtonProps, { color: "gray", onClick: onClose, themeOverride: themeOverride }),
            react_1.default.createElement(CloseIcon_1.CloseIcon, null)))));
}
exports.Notification = Notification;
Notification.displayName = '@mantine/core/Notification';
